import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import AdAssistantStore from "../AdAssistantStore";
import { withRefluxStore } from "../../../Stores";
import { ActionButton, LocationsSearcher } from "@talentbait/shared-components";

import {
  EditCampaignDataModalWrapper,
  Header,
  Content,
  CloseButton,
  Title,
  TitleContainer,
  WarningText,
  WarningContainer,
  ContentContainer,
  ContentTitle,
  TextInput,
  ActionsContainer,
  ActionButtonContainer
} from "./EditCampaignDataModal.styled";
import { WarningIcon, XIcon } from "../../../Components/Icons";
import { useSaveCampaign } from "../hooks/useSaveCampaign";

const EditCampaignDataModal = ({
  onClose,
  campaignId,
  //Store
  campaignData
}) => {
  const { t } = useTranslation();
  const saveCampaign = useSaveCampaign(campaignId);

  const [link, setLink] = useState("");
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    setLink(campaignData.jobPostLink);
  }, [campaignData.jobPostLink]);

  useEffect(() => {
    setLocations(campaignData.locations);
  }, [campaignData.locations]);

  const handleSaveNewCampaign = async () => {
    await saveCampaign({
      ...campaignData,
      jobPostLink: link,
      jobPostingUrl: link,
      locations: locations
    });
  };

  return (
    <EditCampaignDataModalWrapper>
      <Header>
        <TitleContainer>
          <Title>{t("Campaign Settings")}</Title>
          <CloseButton onClick={onClose}>
            <XIcon color="var(--primary-white)" />
          </CloseButton>
        </TitleContainer>
        <WarningContainer>
          <WarningIcon />
          <WarningText>{t("This will update the campaign data for all channels.")}</WarningText>
        </WarningContainer>
      </Header>
      <Content>
        <ContentContainer>
          <ContentTitle>{t("Link")}</ContentTitle>
          <TextInput value={link} onChange={(e) => setLink(e.target.value)} />
        </ContentContainer>
        <ContentContainer>
          <ContentTitle>{t("Locations")}</ContentTitle>
          <LocationsSearcher location={locations} onSelect={setLocations} />
        </ContentContainer>
        <ActionsContainer>
          <ActionButtonContainer>
            <ActionButton variant="secondary" onClick={onClose} text={t("Cancel")} />
            <ActionButton variant="create" onClick={handleSaveNewCampaign} text={t("Save")} />
          </ActionButtonContainer>
        </ActionsContainer>
      </Content>
    </EditCampaignDataModalWrapper>
  );
};

export default withRefluxStore(EditCampaignDataModal, [AdAssistantStore], ["campaignData"]);
